module.exports = __webpack_public_path__ + "static/media/roomsE.31343396.png";